// src/i18n/en/notAuthorized.ts
// English mirror of es/notAuthorized.ts.
export const notAuthorized = {
  title: 'Not authorized',
  description: 'You do not have permission to access this resource.',
  backHome: 'Back to home',
};

export default notAuthorized;
